export interface DrawerSafePadding {
  paddingTop: number;
  paddingBottom: number;
}

/**
 * Web implementation - preserves the original fixed drawer padding so the web
 * layout is unchanged. Web has no system bars to draw behind, so static spacing
 * is intentional here.
 */
export function useDrawerSafePadding(): DrawerSafePadding {
  return {
    paddingTop: 48,
    paddingBottom: 24,
  };
}
